import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthProvider';
import { useMsal } from './contexts/useMsal';
import MenuPage from './pages/MenuPage';
import TestFabricPage from './pages/TestFabricPage';
import MVPPage from './pages/MVPPage';
import './App.css';

const API_URL = import.meta.env.VITE_API_URL;

function AppContent() {
  const { isAuthenticated, isLoading, login, logout, user, getAccessToken } = useMsal();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const apiCalled = useRef(false);

  // Auto-redirect to Entra ID if not authenticated
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      login();
    }
  }, [isLoading, isAuthenticated, login]);

  // After frontend auth, verify with .NET backend
  useEffect(() => {
    if (!isAuthenticated || !user || apiCalled.current) return;

    (async () => {
      apiCalled.current = true;
      try {
        const token = await getAccessToken();

        console.log('Authentication successful:', user);
      } catch (err) {
        console.error('Login error:', err);
        apiCalled.current = false;
      }
    })();
  }, [isAuthenticated, user, getAccessToken]);

  const handleLogout = async () => {
    try {
      await logout();
      setShowLogoutConfirm(false);
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  // ── Render ──

  if (isLoading) {
    return (
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        height: '100vh', color: 'var(--text)', fontFamily: 'var(--font)',
        background: 'var(--bg)',
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="logo" style={{ width: 68, height: 68, margin: '0 auto 16px' }} />
          <p style={{ color: 'var(--muted)' }}>Loading your dashboard…</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h1>Ace App Finops Tool</h1>
          <p>{!isAuthenticated ? 'Redirecting to Microsoft sign-in...' : 'Verifying with server...'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <main className="app-main">
        <Routes>
          <Route path="/" element={<MVPPage />} />
          <Route path="/test" element={<TestFabricPage />} />
          <Route path="/dashboard" element={<MVPPage />} />
          <Route path="/cards" element={<MenuPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}